import * as React from "react";
import { Route, Switch, Redirect, Link, NavLink } from "react-router-dom";
import * as cn from "classnames";
import { History } from "history";
import LocationDescriptor = History.LocationDescriptor;
import Breadcrumb from "components/Breadcrumb";
import RefreshIndicator from "material-ui/RefreshIndicator";
import { secondaryText } from "../../colors";
import BusyFromPromise from "components/BusyFromPromise/BusyFromPromise";
const styles = require("./style.less");

interface SectionTitleProps {
    title: JSX.Element;
    className?: string;
    sectionControl?: React.ReactNode;
    titleLogo?: JSX.Element;
    breadcrumbTitle?: string; // If specified, this text will display above the title.
    breadcrumbPath?: LocationDescriptor; // If specified, this will link your breadcrumb title.
    busy?: Promise<any> | boolean;
    enableLessIntrusiveLoadingIndicator?: boolean;
}

const SectionTitle: React.StatelessComponent<SectionTitleProps> = props => {
    return <div className={cn(styles.container, props.className)}>
        <div className={styles.titleContainer}>
            <Breadcrumb title={props.breadcrumbTitle} path={props.breadcrumbPath} />
            <div className={styles.title}>
                {props.titleLogo && <div className={styles.logo}>{props.titleLogo}</div>}
                <h3 className={styles.header}>{props.title}</h3>
                {/* We show a less intrusive refresh indicator for screens that have auto-refresh implemented (because the main horizontal loading bar is annoying). */}
                <BusyFromPromise promise={props.busy}>
                    {(busy: boolean) => {
                        return busy && props.enableLessIntrusiveLoadingIndicator
                        ? <div className={styles.refreshContainer}>
                            <RefreshIndicator
                                size={28} /* This size matches the .title class line-height */
                                left={10}
                                top={0}
                                status="loading"
                                loadingColor={secondaryText}
                                style={{
                                    display: "inline-block",
                                    position: "relative",
                                    boxShadow: "unset",
                                }}
                            />
                        </div>
                        : null;
                    }}
                </BusyFromPromise>
            </div>
        </div>
        {props.sectionControl}
    </div>;
};

export default SectionTitle;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/SectionTitle/index.tsx